import React, { Component } from 'react';
import { Modal } from 'antd';
import './styles/apply.scss';
import { receiveMessage, sendMessage } from '../../../request/websocket';

class StartCheck extends Component {
  state = {}

  handleCancel = () => { // 关闭websocket
    const { rowData, name, examid, addStatus } = this.props
    var cancelHolter = {
      TYPE: addStatus === 'HOLTER' ? "HOLTER" : addStatus === 'ECG' ? 'ECG' : "EEG",              //参考TYPE类型说明
      PARAM: addStatus === 'HOLTER' ? 'CANCEL_MONITOR' : addStatus === 'ECG' ?"CANCEL_MONITOR":"CANCEL_EEG_MONITOR",      //参考PARAM参数说明
      EXAM_UID: rowData.EXAM_UID || examid,
      NAME: rowData.NAME || name,
      SERVER: window.g.baseURL
    }
    sendMessage(cancelHolter)
    receiveMessage(received_msg => {
      if (received_msg.RETURN_MSG === "取消监控成功") {
        this.props.setTransferStatus(received_msg)
        this.props.onRef(false);
      }
    })
    this.props.onRef(false);
  }

  render() {
    const { visible, rowData, holterData, name, sex, patientId } = this.props
    return (
      <Modal
        className="consulationH"
        width={440}
        title="开始检查"
        visible={visible}
        onCancel={this.handleCancel}
        maskClosable={false}// 点击蒙层不允许关闭
        footer={[]} // 设置footer为空，去掉 取消 确定默认按钮
      >
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <p>姓名：{rowData.NAME || name}</p>
          <p>性别: {rowData.SEX_NAME || sex}</p>
          <p>病历号：{rowData.PATIENT_ID || patientId}</p>
        </div>
        <div style={{ fontSize: '24px', textAlign: 'center', padding: '40px 0px' }}>{holterData ? holterData : "正在查找数据..."}</div>
      </Modal>
    )
  }
}

export default StartCheck;